import { useNavigate } from 'react-router-dom';
import Demo2Nav from '../layout/Demo2Nav';
import { useDemo2Ctx } from '../Demo2Context';
import bgVideo from '../../../assets/bg1.mp4';

export default function Demo2MLogin() {
    const navigate = useNavigate();
    const { toast } = useDemo2Ctx();

    return (
        <>
            <Demo2Nav />
            <div className="sian sian-mobile-stage">
                <div className="phone-frame">
                    <div className="phone-notch" />
                    <div className="phone-screen">
                        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '32px 28px', position: 'relative', overflow: 'hidden' }}>
                            <video autoPlay muted loop playsInline style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: 0 }}>
                                <source src={bgVideo} type="video/mp4" />
                            </video>
                            <div style={{ position: 'absolute', inset: 0, background: 'rgba(0,20,10,0.52)' }} />
                            <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(ellipse 70% 40% at 20% 10%,rgba(30,139,83,0.3),transparent 60%)' }} />
                            <div style={{ position: 'relative', zIndex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
                                <div className="auth-logo-mark" style={{ marginBottom: 14 }}><i className="ri-tree-line" /></div>
                                <div style={{ color: '#fff', fontSize: 19, fontWeight: 800, marginBottom: 2 }}><em style={{ color: '#6EE7B7', fontStyle: 'normal' }}>AIS</em> × 수프로</div>
                                <div style={{ color: 'rgba(255,255,255,.55)', fontSize: 10.5, letterSpacing: '.12em', textTransform: 'uppercase', marginBottom: 6 }}>LH 현장 작업자 앱</div>
                                <span className="lh-badge" style={{ marginBottom: 26 }}><span className="dot" />한국토지주택공사 전용</span>

                                <div style={{ width: '100%', background: '#fff', borderRadius: 20, padding: '22px 20px', boxShadow: '0 20px 50px rgba(0,0,0,0.35)' }}>
                                    <div style={{ fontSize: 15, fontWeight: 800, marginBottom: 14, color: '#1A2B1A' }}>현장 작업자 로그인</div>
                                    <div className="form-group" style={{ marginBottom: 11 }}><input className="form-input" placeholder="아이디" defaultValue="field_worker03" style={{ height: 44 }} /></div>
                                    <div className="form-group" style={{ marginBottom: 14 }}><input type="password" className="form-input" placeholder="비밀번호" defaultValue="demo1234!" style={{ height: 44 }} /></div>
                                    <button className="btn btn-primary w-full btn-lg" onClick={() => { toast('로그인 중...', 'success'); setTimeout(() => navigate('/demo2/mobile/home'), 600); }}>로그인</button>
                                    <button className="btn btn-secondary w-full" style={{ marginTop: 9 }} onClick={() => toast('생체인증(Face ID) 시도', 'success')}><i className="ri-fingerprint-line" /> 생체인증으로 로그인</button>
                                </div>
                                <div style={{ color: 'rgba(255,255,255,.45)', fontSize: 10.5, marginTop: 18 }}>AIS 스마트 수목관리 · 현장 작업자용 v1.0</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
